import { getObjectTextByPropVal } from "@/helpers/arrayHelpers";
import { mailTemplateTypes, mailTemplateLocales } from "@/static/staticData";

export default {
  methods: {
    getTemplateTypeName(id) {
      return this.$t(
        getObjectTextByPropVal(id, mailTemplateTypes, "id", "key")
      );
    },
    getTemplateLocaleName(id) {
      return this.$t(
        getObjectTextByPropVal(id, mailTemplateLocales, "id", "key")
      );
    },
  },
};
